import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signout } from '../auth';
import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Menu,
    MenuItem,
    Avatar,
    ListItemIcon,
    Divider
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';

interface NavbarProps {
    onMenuClick: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onMenuClick }) => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const userEmail = sessionStorage.getItem('userEmail') || 'U';

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = async () => {
        try {
            await signout();
            sessionStorage.removeItem('tokenAdminUI');
            sessionStorage.removeItem('refreshTokenAdminUI');
            sessionStorage.removeItem('userEmail');
            navigate('/login');
        } catch (error) {
            console.error('Erreur lors de la déconnexion', error);
        }
    };

    return (
        <AppBar 
            position="sticky" 
            elevation={0}
            sx={{
                backgroundColor: 'white',
                borderBottom: '1px solid',
                borderColor: 'rgba(0, 0, 0, 0.06)'
            }}
        >
            <Toolbar className="flex justify-between items-center px-4 sm:px-6">
                <div className="flex items-center">
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={onMenuClick}
                        edge="start"
                        className="mr-2 lg:hidden"
                    >
                        <MenuIcon className="text-emerald-700" />
                    </IconButton>
                    
                    <Typography 
                        variant="h6" 
                        className="text-emerald-700 font-semibold hidden sm:block"
                    >
                        Dashboard Wattless
                    </Typography>
                </div>

                {/* Section droite */}
                <div className="flex items-center space-x-4">
                    {/* Badge économie d'énergie
                    <div className="hidden sm:flex items-center bg-emerald-50 rounded-full px-4 py-1.5">
                        <svg 
                            className="w-5 h-5 text-emerald-600 mr-2" 
                            fill="none" 
                            stroke="currentColor" 
                            viewBox="0 0 24 24"
                        >
                            <path 
                                strokeLinecap="round" 
                                strokeLinejoin="round" 
                                strokeWidth="2" 
                                d="M13 10V3L4 14h7v7l9-11h-7z" 
                            />
                        </svg>
                        <span className="text-sm text-emerald-700">Économie d'énergie active</span>
                    </div>*/}

                    {/* Icône notifications */}
                    <IconButton className="text-emerald-600 hover:text-emerald-700">
                        <NotificationsIcon />
                    </IconButton>

                    {/* Profil utilisateur */}
                    <div className="flex items-center space-x-2">
                        <Avatar 
                            onClick={handleMenu}
                            className="bg-emerald-600 cursor-pointer hover:bg-emerald-700 transition-colors"
                        >
                            {userEmail.charAt(0).toUpperCase()}
                        </Avatar>
                        <div className="hidden md:flex flex-col">
                            {/*
                            <Typography variant="subtitle2" className="text-emerald-800">
                                {userEmail}
                            </Typography>
                            <Typography variant="caption" className="text-emerald-600">
                                Administrateur
                            </Typography>
                            */}
                        </div>
                    </div>
                </div>

                {/* Menu profil */}
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    PaperProps={{
                        elevation: 0,
                        sx: {
                            mt: 1.5,
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            backdropFilter: 'blur(8px)',
                            border: '1px solid rgba(0, 0, 0, 0.08)',
                            borderRadius: '0.75rem',
                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                            '& .MuiList-root': {
                                padding: '4px 0',
                            },
                        },
                    }}
                >
                    <MenuItem 
                        onClick={handleClose}
                        className="text-emerald-700 hover:bg-emerald-50 px-4 py-2"
                    >
                        <ListItemIcon>
                            <PersonIcon className="text-emerald-600" fontSize="small" />
                        </ListItemIcon>
                        Mon Profil
                    </MenuItem>
                    <MenuItem 
                        onClick={handleClose}
                        className="text-emerald-700 hover:bg-emerald-50 px-4 py-2"
                    >
                        <ListItemIcon>
                            <SettingsIcon className="text-emerald-600" fontSize="small" />
                        </ListItemIcon>
                        Paramètres
                    </MenuItem>
                    <Divider className="my-1" />
                    <MenuItem 
                        onClick={handleLogout}
                        className="text-red-600 hover:bg-red-50 px-4 py-2"
                    >
                        <ListItemIcon>
                            <LogoutIcon className="text-red-500" fontSize="small" />
                        </ListItemIcon>
                        Déconnexion
                    </MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    );
};

export default Navbar;